<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<div class="edit-dependency-dialog">
	<!-- TITLE -->
	<dialog-titlebar [title]="appStrings.EDIT_DEPENDENCY_TITLE" [showIconButton]="false"> </dialog-titlebar>

	<div class="edit-dependency-dialog__selection">
		<form mat-dialog-content [formGroup]="editDependencyGroup" class="edit-dependency-dialog__form">
			<div class="edit-dependency-dialog__type">
				<span>{{ appStrings.CUSTOM_FIELD_INFO_TYPE }}</span>
				<mat-radio-group class="modal-radio-group-layout" formControlName="type">
					<mat-radio-button
						automationId="dependencyGroup"
						*ngFor="let option of typeOptions"
						[value]="option.value"
					>
						{{ option.label }}
					</mat-radio-button>
				</mat-radio-group>
			</div>

			<div class="edit-dependency-dialog__lag">
				<mat-number-spinner
					[label]="appStrings.EDIT_DEPENDENCY_DIALOG_LAG_DAYS"
					[min]="-1000"
					[max]="1000"
					[floatingPoint]="false"
					formControlName="lag"
				>
				</mat-number-spinner>
			</div>
		</form>
	</div>

	<!-- BUTTONS -->
	<button-footer
		(buttonSaveOrClose)="handleSave()"
		automationId="Save"
		[saveOrCloseButtonText]="appStrings.UICONTROL_TEXT_SAVE | uppercase"
	>
		<button
			*ngIf="dialogData.includeCancelButton"
			middleButton
			mat-button
			color="primary"
			(click)="handleCancel()"
			automationId="cancel"
		>
			{{ appStrings.UICONTROL_TEXT_CANCEL.toUpperCase() }}
		</button>
	</button-footer>
</div>
